const state = { isConnected: true, isInternetReachable: true, type: 'wifi', details: null };

export const NetInfoStateType = {
  unknown: 'unknown',
  none: 'none',
  cellular: 'cellular',
  wifi: 'wifi',
  bluetooth: 'bluetooth',
  ethernet: 'ethernet',
  wimax: 'wimax',
  vpn: 'vpn',
  other: 'other',
};

export const NetInfoCellularGeneration = {
  '2g': '2g',
  '3g': '3g',
  '4g': '4g',
  '5g': '5g',
};

const NetInfo = {
  refresh: () => Promise.resolve(state),
  fetch: () => Promise.resolve({ isConnected: true, isInternetReachable: true, type: 'wifi', details: null }),
  addEventListener: () => () => {},
  useNetInfo: () => ({ isConnected: true, isInternetReachable: true, type: 'wifi', details: null }),
  configure: () => {},
};

export const useNetInfo = () => ({ isConnected: true, isInternetReachable: true, type: 'wifi', details: null });
export const addEventListener = NetInfo.addEventListener;
export const fetch = NetInfo.fetch;
export const refresh = NetInfo.refresh;
export const configure = NetInfo.configure;
export default NetInfo;
